import { makeAcceptedWork } from "./accepted-operation.ts";
import { Context, type Effect, Layer, type Scope } from "effect";

export class AcceptedWork extends Context.Service<AcceptedWork, {
  readonly join: <A, E, R>(accepted: Effect.Effect<A, E, R>) => Effect.Effect<A, E, R>;
}>()("workerstation/frontend/AcceptedWork") {}

/** The accepted scope also admits nested steps of an already accepted action. */
export const AcceptedWorkLive = (root: Scope.Scope, admission: Scope.Scope = root) => Layer.effect(AcceptedWork, makeAcceptedWork(root, admission));
